<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-12 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <a href="#pdfdownloadButton" @click="generateReport" class="btn btn-primary">PDF
            <app-icon name="download"/>
          </a>
        </div>
      </div>
    </div>
    <VueHtml2pdf
      :show-layout="false"
      :float-layout="false"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="2400"
      :filename="pageTitle"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="100%"
      ref="html2Pdf">

      <section slot="pdf-content">
        <div class="row">
          <div class="col-sm-12 col-md-12">
            <!-- <app-breadcrumb
                :page-title="pageTitle"
                :directory="$t('datatables')"
                :icon="'grid'"
            />
            <app-breadcrumb
                :page-title="$t('document_control_register')"
                :directory="$t('datatables')"
                :icon="'grid'"
            /> -->
            <h4>{{ pageTitle }}</h4>
          </div>
        </div>
        <app-table :id="tableId" :options="options" @action="getListAction" />
      </section>
    </VueHtml2pdf>
  </div>
</template>

<script>
import CoreLibrary from "../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../Config/ApiUrl";
import {TableHelpers} from "../Demo/Tables/mixins/TableHelpers";
import {DOCUMENT_CONTROL_REGISTER} from "../../../Config/ApiUrl";

export default {
  extends: CoreLibrary,
  name: "DocumentControlRegister",
  mixins: [TableHelpers],
  data() {
    return {
      company_name: '',
      pageTitle: '',
      formType: '',
      formBody: 0,
      formRevisionId: 0,
      formID: 0,
      user_id: 0,
      isSaveResponseFormModalActive: false,
      isAddResponseCategoryModalActive: false,
      isSaveResponseCategoryImportModalActive: false,
      selectedUrl: "",
      tableId: "document-control-register",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: actions.DOCUMENT_CONTROL_REGISTER,
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
          {
            title: this.$t("Reference"),
            type: "custom-html",
            key: "id",
            modifier: (value,row) => {
              // let companyInfo = this.$store.state.user.loggedInUser.company;
              let companyInfo = this.company_name;
              // return `<a class="text-primary cursor-pointer" id="${row.id+'_'+row.form_id+'_'+row.form_body_id}"  @click.prevent=${this.myFunction(row)}>${this.$t(value.name ?? "---")}</a>`;
              return `<span>${this.$t(companyInfo.match(/\b(\w)/g).join('')+'C'+value)}</span>`;

             },
          },
          {
            title: this.$t("Document Name"),
            type: "custom-html",
            key: "name",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("Revision"),
            type: "custom-html",
            key: "get_revision",
            modifier: (value,row) => {
              return `<span>${(value[0] && value[0].version)}</span>`;
            },
          },
          {
            title: this.$t("Revision Date"),
            type: "custom-html",
            key: "get_revision",
            modifier: (value,row) => {

              let dateValue = value[0]?.updated_at ;
              if (!dateValue) return `<span>-</span>`; // Handle undefined case

              // Parse and format date correctly
              let date = moment(dateValue).format("YYYY-MM-DD HH:mm");

              return `<span>${this.$t(date)}</span>`;
            },
          },
          {
            title: this.$t("Reviewed By"),
            type: "custom-html",
            key: "get_revision",
            modifier: (value) => {
                let fullName = value[0].user && value[0].user.full_name;
              return `<span>${fullName??'---'}</span>`;
            },
          },

        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
          },

        ],
        filters: [
          //     {
          //       title: this.$t("date"),
          //       type: "range-picker",
          //       key: "date",
          //       option: ["today", "thisMonth", "last7Days", "nextYear"],
          //     },
          //     {
          //       title: this.$t("priority"),
          //       type: "checkbox",
          //       key: "priority",
          //       option: [
          //         { id: "low", value: "Low" },
          //         { id: "medium", value: "Medium" },
          //         { id: "high", value: "High" },
          //       ],
          //     },
          //     {
          //       title: this.$t("status"),
          //       type: "checkbox",
          //       key: "status",
          //       option: [
          //         { id: "completed", value: "Completed" },
          //         { id: "incomplete", value: "Incomplete" },
          //         // {id: 'invited', value: 'Invited'},
          //       ],
          //     },
          {
            "title": this.$t('search_by_category'),
            "type": "drop-down-filter",
            "key": "search select",
            "option": [],
          }
        ],
        showFilter: true,
        showSearch: true,
        showCount: false,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  methods: {
    getCompanyName() {
      this.axiosGet(actions.COMPANY_NAME+'/'+ 0)
      .then((response) => {
          this.company_name = response.data.company_name;
          this.pageTitle = this.$t('document_control_register') + ' (' + response.data.company_name + ')';
        })
        .catch((error) => {
          
        });
    },
    generateReport(event) {

      // this.options.showAction = false;
      // this.options.showFilter = false;
      // this.options.showClearFilter = false;
      // this.options.showSearch = false;
      this.$toastr.s('PDF generation is in progress, Please wait.');

      this.$refs.html2Pdf.generatePdf();
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("view")) {
        this.openDocument(rowData);
      }
    },
    openDocument(rowData){
      let searchText = rowData.name??''
      const url = `admin/documentlibrary/mydocument?searchText=${encodeURIComponent(searchText)}`;
      // Open the link in a new tab
      window.open(url, '_blank');
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.RESPONSE_CATEGORY_FILTER_LIST).then((response) => {
        let name = this.options.filters.find(
            (element) => element.title === this.$t("search_by_category")
        );
        name.option = response.data.map((name) => {
          return {
            id: name.id,
            value: name.value,
          };
        });
      });
    },
  },
  mounted() {
    this.getCompanyName();
  },
};
</script>
